<template>
	<div id="body-container">
			<NavBar  :class="{active:'bg-dark'}"/>
			<div class="SessionPopup">
			<SessionPopup />
		</div>
		<div class="overlay" :class="{ active: 'isOverlayActive' }" v-if="isSessionPopupVisible==true"></div>
			<div class="flex bg-dark" @click="closeApps()">
				<div :class="{ 'w-40': isSidebarToggle, 'w-10': !isSidebarToggle }">
					<div class="lg:flex mainlogo">
						<span class="text-lg font-bold ">
							<img src="@/assets/crystaSureLogo.svg" alt=""  v-if="isSidebarToggle" class="crystaSureLogo"/>
							<img src="@/assets/crystaSureShield.svg" alt="" v-else  class="crystaSureShield"/>
						</span>
					</div>
					<div class="fixed sidebar bg-white sidenav sideheight flex flex-col justify-between h-full z-51" :class="{ 'w-40': isSidebarToggle, 'w-10': !isSidebarToggle ,active:'bg-dark-blue'}">
						<ul>
							<li
								@click="navigate('root-Frameworks', 'root-Frameworks')"
								@mouseenter="sidebar.root_Frameworks = true"
								@mouseleave="sidebar.root_Frameworks = false"
								class="cursor-pointer text-black hover:bg-primary svg-icon pl-2 pr-2.5 adjustWidthWhenHover"
								:class="selectedOptionName === 'root-Frameworks' ? 'bg-primary text-white font-bold a svg-icon123 adjustWidthWhenHover' : 'text-black font-normal adjustWidthWhenHover'"
							>
								<div>
									<a class="flex controlalign navchild items-center hover:text-white py-1.5">
										<div class="py-0.5">
										<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
											<g clip-path="url(#clip0_2328_26181)">
												<path
													d="M5.02793 2.80666L1.13449 4.48927L1.12968 5.06084L1.12646 5.63402H1.67074H2.21342L2.22305 5.70627C2.24553 5.87003 2.37879 6.04985 2.53613 6.12692L2.62765 6.17188H8.96954H15.3114L15.3869 6.13655C15.5539 6.05949 15.6968 5.87646 15.716 5.71269L15.7257 5.63402H16.2539H16.7805L16.7773 5.06245L16.7725 4.49087L12.8646 2.80666C10.7164 1.88026 8.94867 1.12245 8.93903 1.12405C8.9294 1.12405 7.16972 1.88187 5.02793 2.80666Z"
													fill="black"
												/>
												<path
													d="M3.19769 10.1138V13.4822L2.89746 13.4902C2.61006 13.4967 2.5908 13.4999 2.49768 13.5416C2.37887 13.5946 2.25042 13.7198 2.19905 13.8322C2.16533 13.9061 2.16212 13.9382 2.1573 14.2689L2.15088 14.627H8.95998H15.7691V14.2818C15.7691 13.9767 15.7659 13.9285 15.737 13.8515C15.6904 13.7262 15.57 13.5994 15.4448 13.5432C15.3484 13.4999 15.3308 13.4967 15.0434 13.4902L14.7415 13.4822V10.1138V6.74374H13.6899H12.6383V10.1154V13.487H12.1245H11.6107V10.1154V6.74374H10.5591H9.50747V10.1154V13.487H8.9937H8.47992V10.1154V6.74374H7.42829H6.37667V10.1154V13.487H5.86289H5.34912V10.1154V6.74374H4.27341H3.19769V10.1138Z"
													fill="black"
												/>
												<path
													d="M1.51675 15.2197C1.36262 15.2727 1.24542 15.3754 1.17156 15.5263C1.13463 15.597 1.13463 15.6114 1.12982 16.236L1.125 16.875H8.95362H16.7838L16.7774 16.252L16.7726 15.6307L16.7277 15.5328C16.6731 15.414 16.5462 15.2855 16.4354 15.2341L16.3552 15.1972L8.97771 15.194C1.91172 15.1908 1.59703 15.1908 1.51675 15.2197Z"
													fill="black"
												/>
											</g>
											<defs>
												<clipPath id="clip0_2328_26181">
													<rect width="18" height="18" fill="white" />
												</clipPath>
											</defs>
										</svg>
										</div>
										<div class="item-name leading-5 text-sm pl-2.5" :class="selectedOptionName === 'root-Frameworks'? 'text-white font-bold' : 'text-listIconColor font-normal'" v-if="isSidebarToggle">Frameworks</div>
									</a>
								</div>
								<div v-if="sidebar.root_Frameworks && !isSidebarToggle" class="bg-tooltip absolute z-50 group-hover:opacity-100 rounded tooltipwidth pointer-events-none transform-y-top left-11 whitespace-nowrap">
									<div class="px-2 text-white" :class="selectedOptionName === 'root-Frameworks'?'font-bold':'font-normal'">Frameworks</div>
								</div>
							</li>
							<li
								@click="navigate('root-controls', 'root-controls')"
								@mouseenter="sidebar.root_controls = true"
								@mouseleave="sidebar.root_controls = false"
								class="cursor-pointer text-black hover:bg-primary svg-icon pl-2 pr-2.5 adjustWidthWhenHover mt-1"
								:class="selectedOptionName === 'root-controls' ? 'bg-primary text-white font-bold a svg-icon123 adjustWidthWhenHover' : 'text-black font-normal adjustWidthWhenHover'"
							>
								<div>
									<a class="flex controlalign navchild items-center hover:text-white py-1.5">
										<div class="py-0.5">
										<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path
												d="M5.29463 2.10857C5.26034 2.07416 5.21959 2.04685 5.17472 2.02822C5.12985 2.00959 5.08174 2 5.03316 2C4.98457 2 4.93647 2.00959 4.8916 2.02822C4.84673 2.04685 4.80598 2.07416 4.77168 2.10857L2.81277 4.0561L2.11448 3.37565C2.08019 3.34124 2.03944 3.31393 1.99457 3.2953C1.9497 3.27667 1.90159 3.26708 1.85301 3.26708C1.80442 3.26708 1.75632 3.27667 1.71145 3.2953C1.66658 3.31393 1.62583 3.34124 1.59153 3.37565L1.10857 3.85922C1.07416 3.89352 1.04685 3.93427 1.02822 3.97914C1.00959 4.02401 1 4.07211 1 4.1207C1 4.16928 1.00959 4.21739 1.02822 4.26226C1.04685 4.30713 1.07416 4.34788 1.10857 4.38217L2.57252 5.84028C2.6456 5.90974 2.74256 5.94847 2.84338 5.94847C2.9442 5.94847 3.04117 5.90974 3.11424 5.84028L3.59381 5.35978L5.81481 3.13909C5.88401 3.06984 5.92311 2.97609 5.92363 2.87819C5.92415 2.78028 5.88604 2.68613 5.81758 2.61614L5.29463 2.10857ZM5.29463 7.00554C5.26034 6.97112 5.21959 6.94382 5.17472 6.92519C5.12985 6.90655 5.08174 6.89696 5.03316 6.89696C4.98457 6.89696 4.93647 6.90655 4.8916 6.92519C4.84673 6.94382 4.80598 6.97112 4.77168 7.00554L2.81277 8.96568L2.11448 8.28584C2.08019 8.25143 2.03944 8.22412 1.99457 8.20549C1.9497 8.18686 1.90159 8.17727 1.85301 8.17727C1.80442 8.17727 1.75632 8.18686 1.71145 8.20549C1.66658 8.22412 1.62583 8.25143 1.59153 8.28584L1.10857 8.76849C1.07416 8.80279 1.04685 8.84354 1.02822 8.88841C1.00959 8.93328 1 8.98138 1 9.02997C1 9.07855 1.00959 9.12666 1.02822 9.17153C1.04685 9.2164 1.07416 9.25715 1.10857 9.29144L2.56883 10.7526C2.64185 10.8221 2.73877 10.8608 2.83954 10.8608C2.9403 10.8608 3.03722 10.8221 3.11024 10.7526L3.5932 10.27L5.8142 8.04836C5.88313 7.97959 5.9221 7.88636 5.92262 7.78899C5.92314 7.69162 5.88517 7.59799 5.81697 7.52849L5.29463 7.00554ZM2.96874 12.3369C2.15386 12.3369 1.47402 12.9982 1.47402 13.8134C1.47402 14.6286 2.15447 15.29 2.96874 15.29C3.36034 15.29 3.73591 15.1344 4.01282 14.8575C4.28973 14.5806 4.4453 14.205 4.4453 13.8134C4.4453 13.4218 4.28973 13.0462 4.01282 12.7693C3.73591 12.4924 3.36034 12.3369 2.96874 12.3369ZM16.2578 12.829H7.39843C7.26789 12.829 7.1427 12.8809 7.0504 12.9732C6.9581 13.0655 6.90624 13.1907 6.90624 13.3212V14.3056C6.90624 14.4361 6.9581 14.5613 7.0504 14.6536C7.1427 14.7459 7.26789 14.7978 7.39843 14.7978H16.2578C16.3883 14.7978 16.5135 14.7459 16.6058 14.6536C16.6981 14.5613 16.75 14.4361 16.75 14.3056V13.3212C16.75 13.1907 16.6981 13.0655 16.6058 12.9732C16.5135 12.8809 16.3883 12.829 16.2578 12.829ZM16.2578 2.98528H7.39843C7.26789 2.98528 7.1427 3.03714 7.0504 3.12944C6.9581 3.22174 6.90624 3.34693 6.90624 3.47747V4.46185C6.90624 4.59238 6.9581 4.71757 7.0504 4.80988C7.1427 4.90218 7.26789 4.95403 7.39843 4.95403H16.2578C16.3883 4.95403 16.5135 4.90218 16.6058 4.80988C16.6981 4.71757 16.75 4.59238 16.75 4.46185V3.47747C16.75 3.34693 16.6981 3.22174 16.6058 3.12944C16.5135 3.03714 16.3883 2.98528 16.2578 2.98528ZM16.2578 7.90716H7.39843C7.26789 7.90716 7.1427 7.95902 7.0504 8.05132C6.9581 8.14362 6.90624 8.26882 6.90624 8.39935V9.38373C6.90624 9.51426 6.9581 9.63945 7.0504 9.73176C7.1427 9.82406 7.26789 9.87592 7.39843 9.87592H16.2578C16.3883 9.87592 16.5135 9.82406 16.6058 9.73176C16.6981 9.63945 16.75 9.51426 16.75 9.38373V8.39935C16.75 8.26882 16.6981 8.14362 16.6058 8.05132C16.5135 7.95902 16.3883 7.90716 16.2578 7.90716Z"
												fill="black"
											/>
										</svg>
										</div>
										<div class="item-name leading-5 text-sm pl-2" :class="selectedOptionName === 'root-controls' ? 'text-white font-bold' : 'text-listIconColor font-normal'" v-if="isSidebarToggle">Internal Controls</div>
									</a>
								</div>
								<div v-if="sidebar.root_controls && !isSidebarToggle" class="bg-tooltip absolute z-50 group-hover:opacity-100 rounded tooltipwidth pointer-events-none transform-y-top left-11 whitespace-nowrap">
									<div class="px-2 text-white" :class="selectedOptionName === 'root-controls'?'font-bold':'font-normal'">Internal Controls</div>
								</div>
							</li>

							<li
								@click="navigate('root-kpis', 'root-kpis')"
								@mouseenter="sidebar.root_kpis = true"
								@mouseleave="sidebar.root_kpis = false"
								class="cursor-pointer text-black hover:bg-primary svg-icon pl-2 pr-2.5 adjustWidthWhenHover mt-1"
								:class="selectedOptionName === 'root-kpis' ? 'bg-primary text-white font-bold a svg-icon123 adjustWidthWhenHover' : 'text-black font-normal adjustWidthWhenHover'"
							>
								<div>
									<a class="flex controlalign navchild items-center hover:text-white py-1.5">
										<div class="py-0.5">
										<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
											<g clip-path="url(#clip0_2328_26181)">
												<path
													d="M5.02793 2.80666L1.13449 4.48927L1.12968 5.06084L1.12646 5.63402H1.67074H2.21342L2.22305 5.70627C2.24553 5.87003 2.37879 6.04985 2.53613 6.12692L2.62765 6.17188H8.96954H15.3114L15.3869 6.13655C15.5539 6.05949 15.6968 5.87646 15.716 5.71269L15.7257 5.63402H16.2539H16.7805L16.7773 5.06245L16.7725 4.49087L12.8646 2.80666C10.7164 1.88026 8.94867 1.12245 8.93903 1.12405C8.9294 1.12405 7.16972 1.88187 5.02793 2.80666Z"
													fill="black"
												/>
												<path
													d="M3.19769 10.1138V13.4822L2.89746 13.4902C2.61006 13.4967 2.5908 13.4999 2.49768 13.5416C2.37887 13.5946 2.25042 13.7198 2.19905 13.8322C2.16533 13.9061 2.16212 13.9382 2.1573 14.2689L2.15088 14.627H8.95998H15.7691V14.2818C15.7691 13.9767 15.7659 13.9285 15.737 13.8515C15.6904 13.7262 15.57 13.5994 15.4448 13.5432C15.3484 13.4999 15.3308 13.4967 15.0434 13.4902L14.7415 13.4822V10.1138V6.74374H13.6899H12.6383V10.1154V13.487H12.1245H11.6107V10.1154V6.74374H10.5591H9.50747V10.1154V13.487H8.9937H8.47992V10.1154V6.74374H7.42829H6.37667V10.1154V13.487H5.86289H5.34912V10.1154V6.74374H4.27341H3.19769V10.1138Z"
													fill="black"
												/>
												<path
													d="M1.51675 15.2197C1.36262 15.2727 1.24542 15.3754 1.17156 15.5263C1.13463 15.597 1.13463 15.6114 1.12982 16.236L1.125 16.875H8.95362H16.7838L16.7774 16.252L16.7726 15.6307L16.7277 15.5328C16.6731 15.414 16.5462 15.2855 16.4354 15.2341L16.3552 15.1972L8.97771 15.194C1.91172 15.1908 1.59703 15.1908 1.51675 15.2197Z"
													fill="black"
												/>
											</g>
											<defs>
												<clipPath id="clip0_2328_26181">
													<rect width="18" height="18" fill="white" />
												</clipPath>
											</defs>
										</svg>
										</div>
										<div class="item-name leading-5 text-sm pl-2" :class="selectedOptionName === 'root-kpis'? 'text-white font-bold' : 'text-listIconColor font-normal'" v-if="isSidebarToggle">KPIs</div>
									</a>
								</div>
								<div v-if="sidebar.root_kpis && !isSidebarToggle" class="bg-tooltip absolute z-50 group-hover:opacity-100 rounded tooltipwidth pointer-events-none transform-y-top left-11 whitespace-nowrap">
									<div class="px-2 text-white" :class="selectedOptionName === 'root-kpis'?'font-bold':'font-normal'">KPIs</div>
								</div>
							</li>

							<!-- <li
								@click="navigate('tenantFrameWorks', 'tenantFrameWorks')"
								@mouseenter="sidebar.tenantFrameWorks = true"
								@mouseleave="sidebar.tenantFrameWorks = false"
								class="cursor-pointer hover:bg-white svg-icon pl-2.5"
								:class="selectedOptionName === 'tenantFrameWorks' ? 'bg-white text-black font-bold a svg-icon123' : 'text-lightgrey font-normal'"
							>
								<div>
									<a class="flex controlalign navchild items-center hover:text-black py-1">
										<div class="py-0.5">
										<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
											<g clip-path="url(#clip0_2328_26181)">
												<path
													d="M5.02793 2.80666L1.13449 4.48927L1.12968 5.06084L1.12646 5.63402H1.67074H2.21342L2.22305 5.70627C2.24553 5.87003 2.37879 6.04985 2.53613 6.12692L2.62765 6.17188H8.96954H15.3114L15.3869 6.13655C15.5539 6.05949 15.6968 5.87646 15.716 5.71269L15.7257 5.63402H16.2539H16.7805L16.7773 5.06245L16.7725 4.49087L12.8646 2.80666C10.7164 1.88026 8.94867 1.12245 8.93903 1.12405C8.9294 1.12405 7.16972 1.88187 5.02793 2.80666Z"
													fill="#E9E9E9"
												/>
												<path
													d="M3.19769 10.1138V13.4822L2.89746 13.4902C2.61006 13.4967 2.5908 13.4999 2.49768 13.5416C2.37887 13.5946 2.25042 13.7198 2.19905 13.8322C2.16533 13.9061 2.16212 13.9382 2.1573 14.2689L2.15088 14.627H8.95998H15.7691V14.2818C15.7691 13.9767 15.7659 13.9285 15.737 13.8515C15.6904 13.7262 15.57 13.5994 15.4448 13.5432C15.3484 13.4999 15.3308 13.4967 15.0434 13.4902L14.7415 13.4822V10.1138V6.74374H13.6899H12.6383V10.1154V13.487H12.1245H11.6107V10.1154V6.74374H10.5591H9.50747V10.1154V13.487H8.9937H8.47992V10.1154V6.74374H7.42829H6.37667V10.1154V13.487H5.86289H5.34912V10.1154V6.74374H4.27341H3.19769V10.1138Z"
													fill="#E9E9E9"
												/>
												<path
													d="M1.51675 15.2197C1.36262 15.2727 1.24542 15.3754 1.17156 15.5263C1.13463 15.597 1.13463 15.6114 1.12982 16.236L1.125 16.875H8.95362H16.7838L16.7774 16.252L16.7726 15.6307L16.7277 15.5328C16.6731 15.414 16.5462 15.2855 16.4354 15.2341L16.3552 15.1972L8.97771 15.194C1.91172 15.1908 1.59703 15.1908 1.51675 15.2197Z"
													fill="#E9E9E9"
												/>
											</g>
											<defs>
												<clipPath id="clip0_2328_26181">
													<rect width="18" height="18" fill="white" />
												</clipPath>
											</defs>
										</svg>
										</div>
										<div class="item-name leading-5 text-sm pl-2" :class="selectedOptionName === 'tenantFrameWorks' ? 'text-black font-bold' : 'text-listIconColor font-normal'" v-if="isSidebarToggle">Tenant FrameWorks</div>
									</a>
								</div>
								<div v-if="sidebar.tenantFrameWorks && !isSidebarToggle" class="bg-tooltip absolute z-50 group-hover:opacity-100 rounded tooltipwidth border pointer-events-none transform-y-top left-11 whitespace-nowrap">
									<div class="px-2 text-white">Tenant FrameWorks</div>
								</div>
							</li> -->
						</ul>
						<ul class="bottomUl">
							<li class="relative">
								<hr class="mb-4" />
								<img src="@/assets/leftarrow.svg" class=" icon arrowIcon leftarrow absolute cursor-pointer" alt="" @click="toggleSideMenuBar()" v-if="isSidebarToggle" />
								<img src="@/assets/rightarrow.svg" class="arrowiconRight icon rightarrow absolute cursor-pointer" alt="" @click="toggleSideMenuBar()" v-else />
							</li>
							<li v-if="userInfo.currentRole == 10207" class="setting">
								<a @click="triggerNavToSettings()" class="flex navchild py-1 pl-2.5">
									<img src="@/assets/settings.svg" class="h-5 icon" :class="{ 'pr-1.5': isSidebarToggle, '': !isSidebarToggle }" />
									<div class="item-name leading-5 text-sm text-black" v-if="isSidebarToggle">Settings</div>
								</a>
							</li>
							<li v-if="userInfo.organisationType == 10701" class="setting">
								<a @click="triggerNavToAdminSettings()" class="flex navchild py-1 pl-2.5">
									<img src="@/assets/settings.svg" class="h-5 icon mr-2" :class="{ 'widthOpen': isSidebarToggle, 'w-4': !isSidebarToggle }" />
									<div class="item-name leading-5 text-sm text-black" v-if="isSidebarToggle">Settings</div>
								</a>
							</li>
						</ul>
						<!-- <div class="fixed shadow z-50 bg-white w-40 px-2 py-1 min-h-30 flex flex-col justify-center" v-if="appsVisible">
							<div class="flex flex-row items-center cursor-pointer">
								<div>
									<img src="@/assets/monitoring.svg" alt="" class="icn h-8 w-8" />
								</div>
								<div class="nav-item-label-container ml-4">
									<div class="text-sm font-semibold">Monitor</div>
								</div>
							</div>
							<div class="flex flex-row items-center">
								<div class="flex flex-row w-2/4 items-center cursor-pointer" @click="triggerNavigation()">
									<img src="../assets/training.svg" alt="" class="icn h-8 w-8" />
									<div class="nav-item-label-container ml-4">
										<div class="text-sm font-semibold">Training</div>
										<div class="active-border"></div>
									</div>
								</div>
							</div>
						</div> -->
					</div>
				</div>
				<div class="content mt-12 flex-1 min-w-0 w-full overflow-hidden" :class="{ toggledstate: isSidebarToggle }"  @scroll="handleScroll">
					<div class="page" :class="flag ? 'margin-bottom1' : 'margin-bottom2'">
						<slot />
					</div>
					<Footer class="bg-dark-blue"/>
				</div>
			</div>
		<detailsModalHost />
	</div>
</template>

<style scoped>
.content {
	height: calc(100vh - 3rem);
	display: flex;
	flex-direction: column;
	min-height: 0;
}
.page{
	flex: 1;
	min-height: 0;
	display: flex;
	flex-direction: column;
	overflow-y: auto;
	margin-bottom: 0;
	padding-bottom: 30px;
}
.page:has(.page-fill) {
	overflow: hidden;
}
.margin-bottom1 {
	margin-bottom: 0;
}
.margin-bottom2 {
	margin-bottom: 0px;
}
.adjustWidthWhenHover{
    border-radius: 5px;
    margin-left:3px;
    margin-right:3px;
}
.leftarrow,
.rightarrow {
	/* height: 1.25rem;
	width: 1.25rem; */
	margin-top: -27px;
}
.a:hover {
	color: white;
	font-weight: 400;
}
.controlalign{
	padding-top:6px;
	padding-bottom: 6px;
}
.svg-icon:hover {
	color: white;
}
.widthOpen{
	width:1rem;
}
.SessionPopup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 20px;
  border-radius: 8px;
  z-index: 99999; /* Ensure it's above other content */
}
.bg-dark.active {
  /* background-color:rgba(8, 8, 8, 0.5); */
  opacity:0.7;
  z-index:999;
}
/* Overlay layer that will apply the black transparent background */
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8); /* Black with opacity */
  z-index: 9999;
  display: none; /* Initially hidden */
}

.overlay.active {
  display: block; /* Show the overlay when active */
}
.bg-dark-blue.active{
	/* background-color:rgba(0, 0, 0, 0.5); */
	opacity: 0.7;
}
.svg-icon123 div a svg path,
.svg-icon123 div a svg rect,
.svg-icon:hover path,
.svg-Image:hover svg path,
.svg-Image:hover svg rect,
.svg-icon:hover rect
 {
    fill: white;
}

.svg-icon123 div a svg path.systems,
.svg-icon:hover path.systems {
	fill: white;
}

.svg-icon123 div a svg path.risks,
.svg-icon:hover path.risks {
	fill: white;
}
/* .sideMenuBarStyle:focus {
	color: #000000;
} */

/* width */
/* ::-webkit-scrollbar {
	width: 10px;
} */

/* Track */
/* ::-webkit-scrollbar-track { */
	/* box-shadow: inset 0 0 3px grey; */
	/* border-radius: 10px; */
/* } */

/* Handle */
/* ::-webkit-scrollbar-thumb {
	background: gray;
	border-radius: 5px;
} */

/* Handle on hover */
/* ::-webkit-scrollbar-thumb:hover {
	background: gray;
} */
 
.sidebar{
	padding-top:85px;
	border-right:1px solid rgb(233, 233, 233);
}
.setting{
    height: 35px;
    margin-top: 5px;
}
.bottomUl{
    height: 51px;
}
.crystaSureShield{
	padding-top:33px ;
	width:20px;
	margin-right: 10px;
}
.crystaSureLogo
{
	padding-top:20px ;
	margin-right: 13px;
	width:150px;
}
.mainlogo{
	position:fixed;
	margin-left:9px;
	z-index:52;
}
 .sideheight{
	height: 100%;
    z-index: 51;
}
.tooltipwidth {
	width: auto;
}
.bg-tooltip {
	background-color: #1976d2;
}
.transform-y-top {
	transform: translateY(-26px);
}
.arrowIcon{
	height:22px;
	width:22px;
	margin-left:157px;
}
.arrowiconRight{
	height:22px;
	width:22px;
	margin-left:29px;
}
</style>

<script lang="ts">
import { mapGetters } from 'vuex';
import NavBar from '@/components/navBar.vue';
import Footer from '@/components/footer.vue';
import { emitter } from '../main';
import { defineComponent } from 'vue';
import SessionPopup from '@/components/sessionpopup.vue';
import detailsModalHost from '@/components/detailsModalHost.vue';


export default defineComponent({
	data() {
		return {
			isSidebarToggle: true,
			flag: true,
			resizeTimeout:0,
			isTogglingData: true,
			manage: false,
			rootControls: false,
			appsVisible: false,
			sideNavSelected: '',
			selectedOptionName: '',
			sidebar: { root_Frameworks: false, root_controls: false, root_kpis: false, tenantFrameWorks: false },
			menus: [
				// {
				// 	optionName: 'manage',
				// 	optionRoute: 'manage',
				// 	defaultoptionImage: require('@/assets/dashboardDefault.svg'),
				// 	colouredoptionImage: require('@/assets/dashboardColoured.svg'),
				// 	displayOptionName: 'Add Config'
				// },
				{
					optionName: 'root-controls',
					optionRoute: 'root-controls',
					defaultoptionImage: require('@/assets/controlsDefault.svg'),
					colouredoptionImage: require('@/assets/controlsColoured.svg'),
					displayOptionName: 'Root Controls'
				},
				{
					optionName: 'root-kpis',
					optionRoute: 'root-kpis',
					defaultoptionImage: require('@/assets/controlsDefault.svg'),
					colouredoptionImage: require('@/assets/controlsColoured.svg'),
					displayOptionName: 'Root KPIs'
				}
			],
			isSessionPopupVisible:false
		};
	},
	components: {
		NavBar,
		Footer,
		SessionPopup,
		detailsModalHost
	},
	computed: {
		currentRouteName(): any {
			return this.$route.name;
		},

		...mapGetters({ userInfo: 'userInfo', toggleState: 'toggle' })
	},
	mounted() {
		this.handleResize()
		window.addEventListener('resize', this.debouncedHandleResize);
		this.isSidebarToggle = this.toggleState;
		let passingRouteName;
		if(this.$route.path.includes('/root/tenant/frameWorks')){
			this.flag=false;
		}else{
			this.flag=true;
		}

		if (this.$route.path.includes('/root/allcontrols')) {
			passingRouteName = 'root-controls';
		} else if (this.$route.path.includes('root-kpis')) {
			passingRouteName = 'root-kpis';
		} else if (this.$route.path.includes('manageControlFrameWork')) {
			passingRouteName = 'tenantFrameWorks';
			// console.log('flag false');
			this.flag = false;
		} else if (this.$route.path.includes('manageRootControlMapping') && this.$route.query.from == 'frameworks') {
			passingRouteName = 'root-Frameworks';
		} else if (this.$route.path.includes('manageRootControlMapping') && this.$route.query.from == 'internalControls') {
			passingRouteName = 'root-controls';
		} else {
			passingRouteName = this.currentRouteName;
		}
		this.selectedOptionName = passingRouteName;
		emitter.on('toggle-sidebar', (isToggle: any) => {
			this.isTogglingData = isToggle;
		});
		emitter.on('apps-sidemenubar', (isToggle: any) => {
			this.appsVisible = isToggle;
		});
		emitter.off('isvisible');
		emitter.on('isvisible',(data:any)=>{
			
		this.isSessionPopupVisible = data;			
		})
	},
	created() {
		emitter.on('sessionPopupVisible',(data:any)=>{
		this.isSessionPopupVisible = data;			
		})
		emitter.off('isvisible');
		emitter.on('isvisible',(data:any)=>{
		this.isSessionPopupVisible = data;			

		})
	},
	methods: {
		navigate(name: any, routerOption: any) {
			this.$store.dispatch('selectedToggle', this.isSidebarToggle);
			this.$store.dispatch('selectedRoute', name);
			if (this.$route.path.includes('/manageControlFrameWork')) {
				this.flag = false;
			} else {
				this.flag = true;
			}
			this.selectedOptionName = name;
			this.$router.push({ name: routerOption });
		},
		debouncedHandleResize() {
            clearTimeout(this.resizeTimeout);
            this.resizeTimeout = setTimeout(this.handleResize, 100); // Adjust debounce time as needed
        },
		goto(name: any, routerOption: any) {
			this.$store.dispatch('selectedToggle', this.isSidebarToggle);
			this.$store.dispatch('selectedRoute', name);
			this.selectedOptionName = name;
			this.$router.push({ name: name, params: { tenantId: this.userInfo.organisationId } });
		},
		triggerNavToSettings() {
			window.location.href = `${process.env.VUE_APP_AUTH_UI}/session?returnTo=${process.env.VUE_APP_ORG_UI}`;
		},
		// triggerNav() {
		// 	window.location.href = `${process.env.VUE_APP_AUTH_WEBAPP_URL}/session?returnTo=${process.env.VUE_APP_MONITOR_WEBAPP_URL}`;
		// },
		triggerNav(app: string) {
			window.location.href = `${process.env.VUE_APP_AUTH_UI}/session?returnTo=${app == 'monitor' ? process.env.VUE_APP_MONITOR_UI : process.env.VUE_APP_WORKFLOW_UI}`;
		},
		triggerNavToAdminSettings() {
			window.location.href = `${process.env.VUE_APP_AUTH_UI}/session?returnTo=${process.env.VUE_APP_ADMIN_UI}`;
		},
		// toggleSideMenuBar() {
		// 	this.isSidebarToggle = !this.isSidebarToggle;
		// 	if (window.innerWidth <= 768) {
		// 		this.isSidebarToggle = false;
		// 	}
		// 	emitter.emit('toggle-sidebar', this.isSidebarToggle);
		// },
		toggleSideMenuBar() {
            this.isSidebarToggle = !this.isSidebarToggle;
            this.$store.dispatch('selectedToggle', this.isSidebarToggle);
            emitter.emit('toggle-sidebar', this.isSidebarToggle);
        },
		handleResize() {
            if(window.innerWidth< 1154 )
            {
				this.$store.dispatch('selectedToggle', false);
				this.isSidebarToggle = false;
				emitter.emit('toggle-sidebar', this.isSidebarToggle);
                // console.log("hii checking reponsive or not");
            }
			else{
				this.$store.dispatch('selectedToggle', true);
				this.isSidebarToggle = true;
				emitter.emit('toggle-sidebar', this.isSidebarToggle);
				// console.log("big screen");
			}
        },
		//    logout() {
		//         this.$http.post(`${process.env.VUE_APP_API_URL}/${process.env.VUE_APP_MONITOR_API_PATH}/api/auth/logout`).then(() => {
		//             this.$router.push({ name: 'login' });
		//             localStorage.removeItem('AUTH_ID');
		//         });
		//     },
		triggerNavigation() {
			window.location.href = `${process.env.VUE_APP_AUTH_UI}/session?returnTo=${process.env.VUE_APP_MONITOR_UI}`;
		},
		closeApps() {
			this.appsVisible = false;
			emitter.emit('apps', this.appsVisible);
		},
		handleScroll() {
			if (this.$route.path.includes('/root/allControls')||this.$route.path.includes('/root-Frameworks')){
				emitter.emit('close-dropdown'); // Emit event to close dropdown on scroll
			}
		}
	}
});
</script>
